/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2020-05-22 15:59:40
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\components\util\ueditor\ueditorForCommand.js
 * @Description:
 */

/**
 * description 策划中心-协同指挥下的编辑器指令
 * created by he.zhikai
 * created on 2018-01-24
 */
'use strict';
angular.module('util.ueditorForCommand', []).directive('ueditorForCommand', [
    '$timeout',
    'ueditorService',
    'ueditorPlugIn',
    function($timeout, ueditorService, ueditorPlugIn) {
        return {
            restrict: 'E',
            scope: {
                htmlContent: '=',
                hasContent: '=', // 编辑器内是否有内容
            },
            replace: true,
            template: "<div><script id='ueditor' style='width:100%;position:relative'></script></div>",
            link: function(scope, element, attrs) {
                var editorToolBar = ueditorService.getToolBar();
                editorToolBar.autoFloatEnabled = false;
                var ue = UE.getEditor('ueditor', editorToolBar);
                var domUtils = baidu.editor.dom.domUtils;
                ue.ready(function() {
                    ue.setContent(scope.htmlContent);
                });
                ue.addListener('contentChange', function() {
                    // 实时双向绑定开始
                    // 编辑器的必填提示
                    $timeout(function() {
                        var content = ue.getContent();
                        if (content !== '') {
                            scope.hasContent = true;
                        } else {
                            scope.hasContent = false;
                        }
                    });
                });
                scope.$on('$destroy', function() {
                    ueditorService.destroyCommonUe(ue);
                });
                ueditorPlugIn.spaceIndent(ue, domUtils);
                ueditorPlugIn.outlinkPicDownload(ue, domUtils);
                ueditorPlugIn.fixContentInImageWrap(ue);
                ueditorPlugIn.fixPasteFromMicoWord(ue);
            },
        };
    },
]);
